import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import SchedulingQuestions from './SchedulingQuestions';
import OverviewConfirmation from './OverviewConfirmation';
import StatusBanner from "../common/StatusBanner";
import Spinner from '../common/spinner';




const InHomeWhatsNext = ({ history, bookApptResult, bookAppointment, pending }) => {
    const [isBookingSuccess, setIsBookingSuccess] = useState(history.location.state?.isBookingSuccess);

    useEffect(() => {
        if (bookApptResult && bookApptResult.success) {
            if (!isBookingSuccess) {
                setIsBookingSuccess(true);
            }
            logUI(`MBHWeb.UI.InHomeSchedulingConfirmation.Success.Displayed`, new Date(), Tools.getURLPath());
        } else {
            logUI(`MBHWeb.UI.InHomeSchedulingConfirmation.Failed.Displayed`, new Date(), Tools.getURLPath());
        }
    }, [bookApptResult]);

    const rebookAppt = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingConfirmation.TryAgain.Clicked`, new Date(), Tools.getURLPath());
        bookAppointment();
    }


    return (
        <>
            {!bookApptResult ? <Redirect to="/inhomeschedule/s7" /> :
                <div className="container-fluid body-content inhome inhome-scheduling inhome-scheduling-container appointment-confirmation-container">
                    <div className="row">
                        <div className="col-12">
                            {isBookingSuccess ? <>
                                <StatusBanner bannerMsg="Thanks, you're all set!" bannerAlignment="left" />
                                <div className="row flex">
                                    <div className="in-home-left-panel scheduling-wrapper">
                                        <div className="detail-wrapper whats-next-wrapper">
                                            <h1 className="page-heading">What's next</h1>
                                            <div className="instructions-info-wrapper">
                                                <div className="info-wrapper">
                                                    <div className="img-wrapper">
                                                        <img src="/images/confirmation.svg" alt="confirm" />
                                                    </div>
                                                    <div className="box">
                                                        <span className="title-text">Now:</span><br />
                                                        <span className="info-text">In a few moments, you will receive an email confirming your appointment.</span><br />
                                                    </div>
                                                    <div className="box">
                                                        <span className="title-text">2 days before your appointment:</span><br />
                                                        <span className="info-text">You will receive a reminder with all of the details and other helpful information.</span><br />
                                                    </div>
                                                    <div className="box">
                                                        <span className="title-text">The day of:</span><br />
                                                        <span className="info-text">The medical professional will contact you on the day of your appointment to confirm everyone will be available at the time and place you selected. A tracking number will be provided to track their progress once they are on their way.</span><br />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="cancel-info-wrapper">
                                                <span className="title-text">To cancel:</span><br />
                                                <span className="info-text">You can cancel this appointment up to 24 hours in advance. Go to your <Link to="/appointments" className="link-text">Appointments</Link> screen for more info.</span>
                                            </div>
                                            <div className="btn-info-wrapper">
                                                <Link to="/">
                                                    <button className="btn btn-primary">Back to Dashboard</button>
                                                </Link>
                                            </div>
                                        </div>
                                        <SchedulingQuestions />
                                        {window.serverData.data.enableQualtricsSurveyInHomeScheduling && <div id="bsw_qtx_inhome_schedule"></div>}
                                    </div>
                                    <div className="in-home-right-panel">
                                        <OverviewConfirmation />
                                    </div>
                                </div>
                            </> :
                                <StatusBanner failedStatus bannerMsg="We were unable to schedule your appointment." bannerAlignment="center" >
                                    <span>Please <span className="btn-try-again" onClick={rebookAppt}>try again</span>.</span>
                                    {pending && <Spinner />}
                                </StatusBanner>}
                        </div>
                    </div>
                </div>
            }</>
    );
}
const mapStateToProps = state => {
    return {
        bookApptResult: state.inHome.bookApptResult,
        pending: state.inHome.bookApptPending,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        bookAppointment: () => {
            dispatch({ type: types.BOOK_INHOME_APPT })
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InHomeWhatsNext);